const GetEOpdDaysName = (id) => {
    switch (id) {
        case "A1": { return "Monday" }
        case "A2": { return "Tuesday" }
        case "A3": { return "Wednesday" }
        case "A4": { return "Thursday" }
        case "A5": { return "Friday" }
        case "A6": { return "Saturday" }
        case "A7": { return "Sunday" }
    }
}

const GetEOpdDays = {
    EOpdDays: [
        { Id: "A1", Name: "Monday" },
        { Id: "A2", Name: "Tuesday" },
        { Id: "A3", Name: "Wednesday" },
        { Id: "A4", Name: "Thursday" },
        { Id: "A5", Name: "Friday" },
        { Id: "A6", Name: "Saturday" },
        { Id: "A7", Name: "Sunday" },
    ]
}

export { GetEOpdDaysName, GetEOpdDays }
